var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("head-nav", { attrs: { menuItems: _vm.menuItems } }),
      _vm._v(" "),
      _c("div", { staticClass: "seg-content page profile-page" }, [
        _c("div", { staticClass: "profile" }, [
          _c("div", { staticClass: "profile-photo" }, [
            _c("div", [
              _c("img", {
                attrs: { src: _vm.photoLinkR(_vm.item.media, 750, 750, "Fit") }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("img", {
                attrs: { src: _vm.photoLinkR(_vm.item.media, 750, 750, "Fit") }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile-details" }, [
            _c("div", { staticClass: "head" }, [
              _c("div", { staticClass: "name" }, [
                _vm._v(
                  _vm._s(
                    _vm.item.pubname ||
                      _vm.item.firstname + " " + _vm.item.lastname
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "properties" }),
            _vm._v(" "),
            _c("ul", { staticClass: "social" }, [
              _vm.item.linkFacebook
                ? _c("li", { staticClass: "fb" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.extLink(_vm.item.linkFacebook),
                          target: "_blank"
                        }
                      },
                      [_vm._v("Facebook")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.linkInstagram
                ? _c("li", { staticClass: "ig" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.extLink(_vm.item.linkInstagram),
                          target: "_blank"
                        }
                      },
                      [_vm._v("Instagram")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.linkTwitter
                ? _c("li", { staticClass: "tw" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.extLink(_vm.item.linkTwitter),
                          target: "_blank"
                        }
                      },
                      [_vm._v("Twitter")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.linkLinkedin
                ? _c("li", { staticClass: "in" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.extLink(_vm.item.linkLinkedin),
                          target: "_blank"
                        }
                      },
                      [_vm._v("LinkedIn")]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "teacher-split" }, [
          _vm.videos.length
            ? _c("div", { staticClass: "videos" }, [
                _c("h2", [_vm._v("Videos")]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "home-list" },
                  _vm._l(_vm.videos, function(item) {
                    return _c(
                      "div",
                      { staticClass: "video hl-wid ww1 wh1 wt0" },
                      [
                        _c("span", { staticClass: "category" }, [
                          _vm._v(_vm._s(item.type && item.type.title))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "language" }, [
                          _vm._v(_vm._s(_vm.languages[item.language]))
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "vx" }, [
                          _vm._v(_vm._s(item.title))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "img" }, [
                          item.media
                            ? _c("img", { attrs: { src: _vm.poster(item) } })
                            : _vm._e(),
                          _c("a", { staticClass: "play", attrs: { href: "" } })
                        ]),
                        _vm._v(" "),
                        item.author
                          ? _c("div", { staticClass: "author" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.photoLinkR(
                                    item.author.media,
                                    512,
                                    512,
                                    "Fit"
                                  )
                                }
                              }),
                              _vm._v(
                                _vm._s(
                                  item.author.firstname +
                                    " " +
                                    item.author.lastname
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "comments" }, [
                          _vm._v(
                            _vm._s(item.comments ? item.comments.length : 0)
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "favs" }, [_vm._v("108")]),
                        _vm._v(" "),
                        _c("router-link", {
                          staticClass: "wlink",
                          attrs: {
                            title: item.title,
                            to: { name: "content", params: { id: item.id } }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "description",
            domProps: { innerHTML: _vm._s(_vm.formatText(_vm.item.pubdesc)) }
          })
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }